import React, { useEffect, useRef, useState } from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import { Link, useNavigate } from "react-router-dom";
import { Styles } from "./styles";
import FooterLogo from "../../Assets/images/logo/logo-footer.png";
import Telegram from "../../Assets/Svg/Telegram.svg";
import Twitter from "../../Assets/Svg/Twitter.svg";
import Youtube from "../../Assets/Svg/youtube.svg";
import Instaram from "../../Assets/Svg/instagram.svg";
import Facebook from "../../Assets/Svg/Facebook.svg";
import Crypto from "../../Assets/crypto.png";
import Payeer from "../../Assets/Payeer.png";
import { Helper } from "../../tools/Helper";
import { api_Routes } from "../../api_Routes";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";
import TelegramIcon from "@mui/icons-material/Telegram";
import CircularProgress from "@mui/material/CircularProgress";
import { isLogin } from "../../tools/Helper";
import DashboardIcon from "../Header/DashbaordIcon";
import DashboardIconLayout from "../Header/DashbaordIconLayout";

// Add these new imports for the popup
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import TextField from "@mui/material/TextField";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import EmailIcon from "@mui/icons-material/Email";

const Alert = React.forwardRef(function Alert(props, ref) {
    return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

const Footer = () => {
    const navigate = useNavigate();
    const [settings, setSettings] = useState({
        location: "",
        contactemail: "",
        contactphonenumber: "",
        twitter: "",
        telegram: "",
        youtube: "",
        instagram: "",
        facebook: "",
    });
    const [showLinks, setShowLinks] = useState(false);
    const [notification, setNotification] = useState({
        open: false,
        message: "",
        severity: "success",
    });
    const [isLoggedIn, setIsLoggedIn] = useState(false);
    const [telegramLoading, setTelegramLoading] = useState(false);

    // New states for guest subscription
    const [subscribeDialogOpen, setSubscribeDialogOpen] = useState(false);
    const [guestEmail, setGuestEmail] = useState("");
    const [emailLoading, setEmailLoading] = useState(false);
    const [emailError, setEmailError] = useState("");

    const [telegramDialogOpen, setTelegramDialogOpen] = useState(false);
    const [guestTelegramEmail, setGuestTelegramEmail] = useState("");
    const [guestTelegramLoading, setGuestTelegramLoading] = useState(false);
    const [guestTelegramError, setGuestTelegramError] = useState("");

    const wrapperRef = useRef(null);

    // Check authentication status
    useEffect(() => {
        const token = localStorage.getItem("user");
        setIsLoggedIn(!!token);
    }, []);

    // Handle clicks outside the component
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
                setShowLinks(false);
            }
        };

        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, []);

    // Load settings data
    useEffect(() => {
        const getData = async () => {
            const { response } = await Helper.Get({
                url: `${api_Routes.Settings.View}`,
                hasToken: true,
            });
            if (response) {
                setSettings({
                    location: response.message?.result?.location || "",
                    contactemail: response.message?.result?.contactemail || "",
                    contactphonenumber: response.message?.result?.contactphonenumber || "",
                    facebook: response.message?.result?.facebook || "",
                    instagram: response.message?.result?.instagram || "",
                    youtube: response.message?.result?.youtube || "",
                    telegram: response.message?.result?.telegram || "",
                    twitter: response.message?.result?.twitter || "",
                });
            }
        };
        getData();
    }, []);

    const handleCloseNotification = (event, reason) => {
        if (reason === "clickaway") {
            return;
        }
        setNotification({ ...notification, open: false });
    };

    const handleDashboardClick = () => {
        navigate("/dashboard/overview");
    };

    const handleSubscribe = async () => {
        if (!isLoggedIn) {
            setSubscribeDialogOpen(true);
            return;
        }

        try {
            const { response, error } = await Helper.Post({
                url: `${api_Routes.Auth.subscribeEmail}`,
                hasToken: true,
            });
            if (response) {
                setNotification({
                    open: true,
                    message: "You've been subscribed successfully!",
                    severity: "success",
                });
            } else if (error) {
                setNotification({
                    open: true,
                    message: error.message || "Subscription failed. Please try again.",
                    severity: "error",
                });
            }
        } catch (err) {
            setNotification({
                open: true,
                message: "An error occurred during subscription",
                severity: "error",
            });
        }
    };

    // New function for guest subscription
    const handleGuestSubscribe = async () => {
        setEmailError("");

        // Basic email validation
        if (!guestEmail) {
            setEmailError("Email is required");
            return;
        }

        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailRegex.test(guestEmail)) {
            setEmailError("Please enter a valid email address");
            return;
        }

        setEmailLoading(true);

        try {
            const { response, error } = await Helper.Post({
                url: `${api_Routes.Auth.subscribeEmailGuest}`,
                data: { email: guestEmail },
                hasToken: false,
            });

            if (response) {
                setNotification({
                    open: true,
                    message: "You've been subscribed successfully!",
                    severity: "success",
                });
                setSubscribeDialogOpen(false);
                setGuestEmail("");
            } else{
                console.log('error')
                const errorMessage = error.message ||
                    error.response?.data?.message ||
                    "Subscription failed. Please try again.";
                setEmailError(errorMessage);
            }
        } catch (err) {
            console.log('error')
            setNotification({
                open: true,
                message: "An error occurred during subscription",
                severity: "error",
            });
        } finally {
            setEmailLoading(false);
        }
    };

    const handleTelegramSubscribe = async () => {
        if (!isLoggedIn) {
            setTelegramDialogOpen(true);
            return;
        }

        setTelegramLoading(true);

        try {
            const { response, error } = await Helper.Post({
                url: `${api_Routes.Auth.subscribeTelegram}`,
                hasToken: true,
            });

            if (response && response.message) {
                if (response.link){
                    window.open(response.link, "_blank");
                    setNotification({
                        open: true,
                        message: "Telegram connection started! Please complete the process in Telegram.",
                        severity: "info",
                    });
                } else {
                    setNotification({
                        open: true,
                        message: response.message,
                        severity: "success",
                    });
                }
            } else {
                const errorMessage = error?.message ||
                    error?.response?.data?.message ||
                    "Failed to generate Telegram link";

                setNotification({
                    open: true,
                    message: errorMessage,
                    severity: "error",
                });
            }
        } catch (err) {
            setNotification({
                open: true,
                message: "An error occurred while connecting to Telegram",
                severity: "error",
            });
        } finally {
            setTelegramLoading(false);
        }
    };

    // New function for guest Telegram subscription
    const handleGuestTelegramSubscribe = async () => {
        setGuestTelegramError("");

        // Email is optional but if provided, validate it
        if (guestTelegramEmail && !/\S+@\S+\.\S+/.test(guestTelegramEmail)) {
            setGuestTelegramError("Please enter a valid email address");
            return;
        }

        setGuestTelegramLoading(true);

        try {
            const { response, error } = await Helper.Post({
                url: `${api_Routes.Auth.subscribeTelegramGuest}`, // You'll need to add this to your api_Routes
                data: {
                    email: guestTelegramEmail || null
                },
                hasToken: false,
            });

            if (response && response.data?.link) {
                window.open(response.data.link, "_blank");
                setNotification({
                    open: true,
                    message: "Telegram connection started! Please complete the process in Telegram. The link will expire in 15 minutes.",
                    severity: "info",
                });
                setTelegramDialogOpen(false);
                setGuestTelegramEmail("");
            } else if (error) {
                const errorMessage = error.message ||
                    error.response?.data?.message ||
                    "Failed to generate Telegram link";
                setGuestTelegramError(errorMessage);
            }
        } catch (err) {
            setNotification({
                open: true,
                message: "An error occurred while generating Telegram link",
                severity: "error",
            });
        } finally {
            setGuestTelegramLoading(false);
        }
    };

    const handleTelegramDialogClose = () => {
        setTelegramDialogOpen(false);
        setGuestTelegramEmail("");
        setGuestTelegramError("");
    };


    const handleDialogClose = () => {
        setSubscribeDialogOpen(false);
        setGuestEmail("");
        setEmailError("");
    };

    return (
        <Styles>
            <Box className="footer" sx={{ padding: { xs: "40px", sm: "40px 80px" } }}>
                <Grid
                    container
                    spacing={4}
                    sx={{
                        flexDirection: { xs: "column", md: "row" },
                        alignItems: { xs: "center", md: "normal" },
                    }}
                >
                    {/* First Column */}
                    <Grid item xs={12} md={4}>
                        <Box>
                            <Box sx={{ display: "flex", justifyContent: { xs: "center", md: "start" } }}>
                                <img src={FooterLogo} alt="Footer Logo" width={200}/>
                            </Box>
                            <Typography className="footer-description">
                                Unlock the full potential of your online presence with our
                                tailored social media panel services.
                            </Typography>
                            {
                                isLogin ? <Box sx={{marginTop:5}}>
                                        <DashboardIconLayout
                                            onClick={handleDashboardClick}
                                            ariaLabel="Dashboard"
                                            showText={true}
                                        >
                                            <DashboardIcon/>
                                        </DashboardIconLayout>
                                    </Box>:
                                    <Box sx={{ marginTop: 5 }}>
                                        <Button
                                            variant="contained"
                                            sx={{
                                                backgroundColor: "#c2ddd1",
                                                color: "#F1F5FD",
                                                borderRadius: "12px",
                                                "&:hover": { backgroundColor: "#4ea27d" },
                                                border: "2px solid #3F78E0",
                                                display: "flex",
                                                gap: "10px",
                                                padding: "10px 12px",
                                                boxShadow: "0px 4px 4px #00000040",
                                            }}
                                            onClick={() => navigate("/signup")}
                                        >
                                            <Typography
                                                sx={{
                                                    textTransform: "capitalize",
                                                    fontWeight: "500",
                                                    fontSize: "16px",
                                                    color: "#F1F5FD",
                                                    whiteSpace: "nowrap",
                                                }}
                                            >
                                                Sign up
                                            </Typography>
                                            <svg
                                                className="sign-up-arrow"
                                                width="17"
                                                height="17"
                                                viewBox="0 0 17 17"
                                                fill="none"
                                                xmlns="http://www.w3.org/2000/svg"
                                            >
                                                <path
                                                    d="M11.2441 2.8457H14.0653C14.4394 2.8457 14.7982 2.99432 15.0627 3.25885C15.3273 3.52339 15.4759 3.88218 15.4759 4.25629V14.1304C15.4759 14.5045 15.3273 14.8633 15.0627 15.1278C14.7982 15.3924 14.4394 15.541 14.0653 15.541H11.2441"
                                                    stroke="white"
                                                    strokeWidth="1.41059"
                                                    strokeLinecap="round"
                                                    strokeLinejoin="round"
                                                />
                                                <path
                                                    d="M7.7168 12.7199L11.2433 9.19346L7.7168 5.66699"
                                                    stroke="white"
                                                    strokeWidth="1.41059"
                                                    strokeLinecap="round"
                                                    strokeLinejoin="round"
                                                />
                                                <path
                                                    d="M11.2428 9.19336H2.7793"
                                                    stroke="white"
                                                    strokeWidth="1.41059"
                                                    strokeLinecap="round"
                                                    strokeLinejoin="round"
                                                />
                                            </svg>
                                        </Button>
                                    </Box>
                            }

                        </Box>
                    </Grid>

                    {/* Second Column */}
                    <Grid item xs={12} md={2.5} style={{ placeItems: "center" }}>
                        <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                            <Typography className="footer-title" textAlign="center">
                                Location & Contact
                            </Typography>
                            <Typography className="footer-contact" textAlign="center">
                                <span>{settings.location}</span>
                                <span>{settings.contactemail}</span>
                                <span>{settings.contactphonenumber}</span>
                            </Typography>
                        </Box>
                    </Grid>

                    {/* Third Column */}
                    <Grid item xs={12} md={1.8} style={{ placeItems: "center" }}>
                        <Typography className="footer-title">Links</Typography>
                        <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                            <Link className="footerroute" to="/home">
                                Services Finder
                            </Link>
                            <Link className="footerroute" to="/OurServices">
                                Our Services
                            </Link>
                            <Link className="footerroute" to="/AddPanel">
                                Add Panel
                            </Link>
                        </Box>
                    </Grid>

                    {/* Fourth Column */}
                    <Grid item xs={12} md={1.8} style={{ placeItems: "center" }}>
                        <Typography className="footer-title">More Links</Typography>
                        <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                            <Link className="footerroute" to="/Team">
                                Our Team
                            </Link>
                            <Link className="footerroute" to="/FAQ">
                                FAQ
                            </Link>
                            <Link className="footerroute" to="/About">
                                About Us
                            </Link>
                            <Link className="footerroute" to="/Terms">
                                Terms
                            </Link>
                        </Box>
                    </Grid>

                    {/* Fifth Column - Subscribe */}
                    <Grid item xs={12} md={1.9} style={{ placeItems: "center" }}>
                        <Typography className="footer-title">Subscribe</Typography>
                        <Box sx={{
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                            gap: "10px"
                        }}>
                            <Typography sx={{ textAlign: "center", fontSize: "14px" }}>
                                Get our latest offers and news
                            </Typography>

                            <Box sx={{ display: "flex", flexDirection: "column", gap: "10px" }}>
                                {/* Email Subscribe Button */}
                                <Button
                                    sx={{
                                        color: "#4ea27d",
                                        border: "solid 2px #4ea27d",
                                        width: "110px",
                                        borderRadius: "8px",
                                        fontSize: "15px",
                                        lineHeight: "20px",
                                        fontWeight: "500",
                                        boxShadow: `
                                            -2px 4px 4px #00000040,
                                            inset 0px 5px 10px #FFFFFF40
                                        `,
                                        background: "white",
                                        "&:hover": {
                                            backgroundColor: "#c2ddd1",
                                        },
                                    }}
                                    onClick={handleSubscribe}
                                >
                                    Email
                                </Button>

                                {/* Telegram Subscribe Button */}
                                <Button
                                    startIcon={
                                        telegramLoading ?
                                            <CircularProgress size={20} color="inherit" /> :
                                            <TelegramIcon fill='#c2ddd1'/>
                                    }
                                    sx={{
                                        color: "#4ea27d",
                                        border: "solid 2px #0088cc",
                                        width: "110px",
                                        borderRadius: "8px",
                                        fontSize: "15px",
                                        lineHeight: "20px",
                                        fontWeight: "500",
                                        boxShadow: `
                                            -2px 4px 4px #00000040,
                                            inset 0px 5px 10px #FFFFFF40
                                        `,
                                        background: "white",
                                        "&:hover": {
                                            backgroundColor: "#c2ddd1",
                                        },
                                        "& .MuiButton-startIcon": {
                                            marginRight: telegramLoading ? 0 : "4px",
                                            marginLeft: telegramLoading ? "8px" : "0",
                                        },
                                        "&:disabled": {
                                            opacity: telegramLoading ? 1 : 0.7,
                                        }
                                    }}
                                    onClick={handleTelegramSubscribe}
                                    disabled={telegramLoading}
                                >
                                    {telegramLoading ? "Loading..." : "Telegram"}
                                </Button>
                            </Box>
                        </Box>
                    </Grid>
                </Grid>

                {/* Bottom Row */}
                <Grid
                    container
                    spacing={4}
                    sx={{
                        flexDirection: { xs: "column-reverse", md: "row" },
                        alignItems: { xs: "center", md: "normal" },
                        marginTop: "20px",
                    }}
                >
                    <Grid
                        item
                        xs={12}
                        md={5}
                        sx={{
                            display: "flex",
                            flexDirection: { xs: "column", sm: "row" },
                            alignItems: "center",
                            justifyContent: "center",
                            gap: "20px",
                        }}
                    >
                        <Typography sx={{ fontSize: "14px" }}>
                            © 2022 SMMAction. All rights reserved
                        </Typography>
                        <Link
                            className="footerroute"
                            to="/PrivacyPolicy"
                            style={{ margin: "0", padding: "0", fontSize: "14px" }}
                        >
                            Privacy Policy
                        </Link>
                        <Link
                            className="footerroute"
                            to="/Terms"
                            style={{ margin: "0", padding: "0", fontSize: "14px" }}
                        >
                            Term of use
                        </Link>
                    </Grid>

                    <Grid
                        item
                        xs={12}
                        md={3}
                        sx={{
                            display: "flex",
                            flexDirection: "row",
                            alignItems: "center",
                            gap: "20px",
                        }}
                    >
                        <Typography>Payments</Typography>
                        <img src={Crypto} alt="crypto" />
                        <img src={Payeer} alt="Payeer" />
                    </Grid>

                    <Grid
                        item
                        xs={12}
                        md={4}
                        sx={{
                            display: "flex",
                            flexDirection: "row",
                            gap: "50px",
                            alignItems: "center",
                            flexWrap: "wrap",
                            justifyContent: { xs: "center", md: "flex-end" },
                        }}
                    >
                        {
                            settings.telegram &&
                            <a href={`https://t.me/${settings.telegram}`} target="_blank" rel="noopener noreferrer">
                                <img src={Telegram} alt="Telegram" />
                            </a>
                        }
                        {
                            settings.twitter &&
                            <a href={settings.twitter} target="_blank" rel="noopener noreferrer">
                                <img src={Twitter} alt="Twitter" />
                            </a>
                        }
                        {
                            settings.youtube &&
                            <a href={settings.youtube} target="_blank" rel="noopener noreferrer">
                                <img src={Youtube} alt="Youtube" />
                            </a>
                        }
                        {
                            settings.instagram &&
                            <a href={settings.instagram} target="_blank" rel="noopener noreferrer">
                                <img src={Instaram} alt="Instagram" />
                            </a>
                        }
                        {
                            settings.facebook &&
                            <a href={settings.facebook} target="_blank" rel="noopener noreferrer">
                                <img src={Facebook} alt="Facebook" />
                            </a>
                        }

                    </Grid>
                </Grid>
            </Box>

            {/* Subscribe Dialog for Guests */}
            <Dialog
                open={subscribeDialogOpen}
                onClose={handleDialogClose}
                maxWidth="sm"
                fullWidth
            >
                <DialogTitle>
                    Subscribe to Newsletter
                    <IconButton
                        aria-label="close"
                        onClick={handleDialogClose}
                        sx={{
                            position: 'absolute',
                            right: 8,
                            top: 8,
                            color: (theme) => theme.palette.grey[500],
                        }}
                    >
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>
                <DialogContent>
                    <Typography sx={{ mb: 2 }}>
                        Enter your email address to subscribe to our newsletter and receive updates.
                    </Typography>
                    <TextField
                        autoFocus
                        margin="dense"
                        label="Email Address"
                        type="email"
                        fullWidth
                        variant="outlined"
                        value={guestEmail}
                        onChange={(e) => {
                            setGuestEmail(e.target.value);
                            setEmailError("");
                        }}
                        error={!!emailError}
                        helperText={emailError}
                        disabled={emailLoading}
                    />
                </DialogContent>
                <DialogActions>
                    <Button
                        onClick={handleDialogClose}
                        disabled={emailLoading}
                    >
                        Cancel
                    </Button>
                    <Button
                        onClick={handleGuestSubscribe}
                        variant="contained"
                        disabled={emailLoading}
                        startIcon={emailLoading ? <CircularProgress size={20} /> : null}
                    >
                        {emailLoading ? "Subscribing..." : "Subscribe"}
                    </Button>
                </DialogActions>
            </Dialog>

            <Dialog
                open={telegramDialogOpen}
                onClose={handleTelegramDialogClose}
                maxWidth="sm"
                fullWidth
            >
                <DialogTitle>
                    Subscribe to Telegram
                    <IconButton
                        aria-label="close"
                        onClick={handleTelegramDialogClose}
                        sx={{
                            position: 'absolute',
                            right: 8,
                            top: 8,
                            color: (theme) => theme.palette.grey[500],
                        }}
                    >
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>
                <DialogContent>
                    <Typography sx={{ mb: 2 }}>
                        Subscribe to our Telegram channel to receive updates and notifications.
                    </Typography>
                    <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                        💡 <strong>Optional:</strong> Provide your email to receive additional updates and manage your preferences.
                    </Typography>
                    <TextField
                        autoFocus
                        margin="dense"
                        label="Email Address (Optional)"
                        type="email"
                        fullWidth
                        variant="outlined"
                        value={guestTelegramEmail}
                        onChange={(e) => {
                            setGuestTelegramEmail(e.target.value);
                            setGuestTelegramError("");
                        }}
                        error={!!guestTelegramError}
                        helperText={guestTelegramError}
                        disabled={guestTelegramLoading}
                        placeholder="your@email.com"
                    />
                    <Typography variant="caption" color="text.secondary" sx={{ mt: 1, display: 'block' }}>
                        We'll generate a secure link that expires in 15 minutes.
                    </Typography>
                </DialogContent>
                <DialogActions>
                    <Button
                        onClick={handleTelegramDialogClose}
                        disabled={guestTelegramLoading}
                    >
                        Cancel
                    </Button>
                    <Button
                        onClick={handleGuestTelegramSubscribe}
                        variant="contained"
                        disabled={guestTelegramLoading}
                        startIcon={
                            guestTelegramLoading ?
                                <CircularProgress size={20} /> :
                                <TelegramIcon />
                        }
                        sx={{
                            backgroundColor: '#0088cc',
                            '&:hover': {
                                backgroundColor: '#0077b3',
                            }
                        }}
                    >
                        {guestTelegramLoading ? "Generating Link..." : "Get Telegram Link"}
                    </Button>
                </DialogActions>
            </Dialog>

            {/* Notification Snackbar */}
            <Snackbar
                open={notification.open}
                autoHideDuration={6000}
                onClose={handleCloseNotification}
                anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
            >
                <Alert
                    onClose={handleCloseNotification}
                    severity={notification.severity}
                    sx={{ width: "100%" }}
                >
                    {notification.message}
                </Alert>
            </Snackbar>
        </Styles>
    );
};

export default Footer;